import { ICommonInputProps, TRequestParams } from "../../../shared/commonTypes/commonTypes";

export interface IResetPasswordStore {
    emailInput: ICommonInputProps;
    isRequestSent: boolean;
    cooldownEnd: number;
}

export enum TResetPasswordInputKey {
	EMAIL_INPUT = 'emailInput',
}

export type TEmailInput = Pick<IResetPasswordStore, TResetPasswordInputKey.EMAIL_INPUT>;

export type CheckResult =
    | { isValid: true; requestParams: TRequestParams }
    | { isValid: false };